import { isSuperAdmin } from './roles.js'

/**
 * Home route for a user profile based on role.
 * @param {object|null} profile
 * @param {{ influencerAfterJoin?: boolean }} [options]
 */
export function roleHomePath(profile, { influencerAfterJoin = false } = {}) {
  if (!profile) return '/login'
  if (isSuperAdmin(profile)) return '/super-admin'
  const role = profile.role_canonical || profile.role
  if (role === 'client') return '/client'
  if (role === 'influencer') {
    return influencerAfterJoin ? '/influencer/onboarding' : '/influencer'
  }
  if (role === 'account_manager' || role === 'admin') return '/admin'
  return '/login'
}
